import { render, staticRenderFns } from "./TechInfoSerialSearchResults.vue?vue&type=template&id=2c4c508a&"
import script from "./TechInfoSerialSearchResults.vue?vue&type=script&lang=js&"
export * from "./TechInfoSerialSearchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports